import React from 'react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  editScreen,
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
  BooleanFlagFilterCell,
  GridFlag,
}) => {
  const dataColumns = [
    {
      field: 'ConnectionId',
      title: 'Connection Id',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      cell: (props) => (
        <td
          className='edit-link'
          onClick={() => {
            editScreen(props.dataItem);
          }}
        >
          {props.dataItem.ConnectionId}
        </td>
      ),
    },
    {
      field: 'IntegrationId',
      title: 'Integration Id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'RowNo',
      title: 'RowNo',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 50,
      excludeFromFilter: true,
    },
    {
      field: 'TenantId',
      title: 'Tenant Id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 150,
      excludeFromFilter: true,
    },
    {
      field: 'SysType',
      title: 'System Type',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'ConnectionTypeName',
      title: 'Connection Type',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'Description',
      title: 'Description',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'AuthEndpointUrl',
      title: 'Auth Endpoint Url',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'ApiEndpointUrl',
      title: 'Api Endpoint Url',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'Active',
      title: 'Active',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanFlagFilterCell,
    },
    {
      field: 'CreatedBy',
      title: 'Created By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'CreatedDate',
      title: 'Created Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'CreatedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'ModifiedBy',
      title: 'Modified By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'ModifiedDate',
      title: 'Modified Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'ModifiedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
  ];

  return dataColumns;
};
export default DataColumns;
